import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  Droplets,
  Square,
  Flame,
  CloudRain,
  Home,
  Truck,
  ChefHat,
  LayoutGrid,
  ArrowUpRight,
} from "lucide-react";
import { SERVICES } from "@/lib/constants";

const ICONS = { Droplets, Square, Flame, CloudRain, Home, Truck, ChefHat, LayoutGrid };

export const Services = () => {
  const navigate = useNavigate();
  return (
    <section id="services" className="relative py-24 sm:py-32 bg-[#0B1726]" data-testid="services-section">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-10 bg-[#1E88E5]" />
              <span className="font-heading text-xs font-bold tracking-[0.3em] uppercase text-[#1E88E5]">
                What we clean
              </span>
            </div>
            <h2 className="font-heading text-4xl sm:text-6xl font-black uppercase tracking-tight text-white">
              Every surface. <br className="hidden sm:block" />
              <span className="text-[#1E88E5]">Done right.</span>
            </h2>
          </div>
          <p className="text-slate-400 max-w-md text-lg leading-relaxed">
            From weekly gutter maintenance to one-off fleet decontamination — pick a
            service and get a quote in under a minute.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => {
            const Icon = ICONS[s.icon] || Droplets;
            return (
              <motion.button
                key={s.id}
                type="button"
                onClick={() => navigate(s.href || "/quote")}
                data-testid={`service-card-${s.id}`}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="group text-left bg-[#142238] border border-slate-800 hover:border-[#1E88E5] p-8 rounded-md transition-all duration-300 flex flex-col h-full hover:-translate-y-1 hover:shadow-[0_20px_50px_-15px_rgba(0,85,255,0.35)]"
              >
                <div className="w-14 h-14 rounded-sm bg-[#1E88E5]/10 border border-[#1E88E5]/30 flex items-center justify-center mb-6 group-hover:bg-[#1E88E5] transition-colors">
                  <Icon className="w-7 h-7 text-[#1E88E5] group-hover:text-white transition-colors" strokeWidth={1.5} />
                </div>
                <h3 className="font-heading text-2xl font-bold uppercase tracking-tight text-white mb-3">
                  {s.name}
                </h3>
                <p className="text-slate-400 text-base leading-relaxed flex-1">{s.short}</p>
                <div className="mt-6 flex items-center gap-2 font-heading uppercase text-sm tracking-wider text-[#E6B445] group-hover:text-white transition-colors">
                  {s.href ? "Explore" : "Get a quote"}
                  <ArrowUpRight className="w-4 h-4 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </div>
              </motion.button>
            );
          })}
        </div>
      </div>
    </section>
  );
};
